import { FC } from 'react';

export const ArrowRight: FC = () => (
    <svg style={{ verticalAlign: "text-top" }} xmlns="http://www.w3.org/2000/svg" width="21" height="20" viewBox="0 0 21 20" fill="none">
        <mask id="mask0_31_1142" style={{ maskType: "alpha" }} maskUnits="userSpaceOnUse" x="4" y="0" width="11" height="20">
            <path d="M5.08252 20C4.91585 20 4.75835 19.935 4.64085 19.8167C4.39752 19.5733 4.39752 19.1767 4.64085 18.9325L13.5742 10L4.64085 1.06667C4.52252 0.949167 4.45752 0.791667 4.45752 0.625C4.45752 0.458333 4.52252 0.300833 4.64085 0.183333C4.75835 0.065 4.91585 0 5.08252 0C5.24919 0 5.40669 0.065 5.52419 0.183333L14.4575 9.11667C14.9442 9.60333 14.945 10.3958 14.4584 10.8825L5.52419 19.8167C5.40669 19.935 5.24919 20 5.08252 20Z" fill="white" />
        </mask>
        <g mask="url(#mask0_31_1142)">
            <rect x="0.5" width="20" height="20" fill="#0077FF" />
        </g>
    </svg>
);
